module.exports = __webpack_public_path__ + "static/media/finanziamenti-mobile.fd87a99b.svg";